<template>
  <div>
    <div class="account-header">
      <div class="header-box">
        <div class="header-logo">
          <a
            :href="siteConfig.logoLink == '' ? '/' : siteConfig.logoLink"
            v-show="siteConfig.logo"
          >
            <img :src="concatImageUrl(siteConfig.logo)" />
          </a>
        </div>
      </div>
    </div>
    <div class="account-body">
      <div class="account-box">
        <div class="account-img">
          <div
            class="img"
            v-if="siteConfig.loginImage"
            :style="
              'background: url(' +
              concatImageUrl(siteConfig.loginImage) +
              ') no-repeat center;'
            "
          ></div>
          <div
            class="img"
            v-else
            :style="
              'background: url(' +
              require('../../assets/images/v3/account-default-cover.png') +
              ') no-repeat center'
            "
          ></div>
        </div>
        <div class="account-wrapper">
          <div
            class="account-tab"
            :class="{ col3: siteConfig.agencyId == this.customLoginId }"
          >
            <span
              :class="{ selected: loginType === 1 }"
              @click="changeLoginType(1)"
              v-if="siteConfig.agencyId != this.customLoginId"
              >用户名登录</span
            >
            <span
              :class="{ selected: loginType === 2 }"
              @click="changeLoginType(2)"
              v-if="siteConfig.agencyId != this.customLoginId"
              >手机号登录</span
            >
            <span
              :class="{ selected: loginType === 3 }"
              v-if="siteConfig.agencyId == this.customLoginId"
              @click="changeLoginType(3)"
            >
              用户登录
            </span>
          </div>
          <div class="account-error">
            <template v-if="errorTip">
              <Icon type="md-alert" size="18" />
              <span>{{ errorTip }}</span>
            </template>
          </div>
          <form
            v-if="loginType === 1 || loginType === 2"
            class="account-form"
            @submit.prevent="submit($event)"
          >
            <div class="form-item">
              <i-input
                v-model="username"
                type="text"
                :placeholder="userPlaceholder"
                @on-change="checkUserName($event)"
                size="large"
              >
                <Icon
                  v-if="loginType === 1"
                  custom="ich-icon ich-icon-user"
                  slot="prefix"
                />
                <Icon v-else custom="ich-icon ich-icon-phone" slot="prefix" />
              </i-input>
            </div>
            <div class="form-item">
              <i-input
                v-model.trim="password"
                type="password"
                password
                placeholder="请输入密码"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-lock" slot="prefix" />
              </i-input>
            </div>
            <div class="form-item">
              <i-input
                name="verifycode"
                maxlength="4"
                placeholder="请输入验证码"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-diamond" slot="prefix" />
                <span class="verify-code" @click="getCodeUrl()" slot="suffix">
                  <img
                    id="verifyCode"
                    title="点击刷新"
                    alt="验证码"
                    :src="verifyCodeUrl"
                    style="cursor: pointer"
                  />
                </span>
              </i-input>
            </div>

            <div class="form-item clearfix">
              <label class="fl">
                <Checkbox v-model="autoLogin">下次自动登录</Checkbox>
              </label>
              <router-link :to="{ path: '/forget' }">
                <a href="javascript:;" class="fr" style="color: #ff6a00"
                  >忘记密码</a
                >
              </router-link>
            </div>
            <!-- <div class="form-item" style="font-size: 13px; color: red">
              密码错误2次,密码错误次数达到10次后将锁定账号30分钟
            </div> -->
            <div class="form-item">
              <button type="submit" class="submit-btn">登 录</button>
            </div>
          </form>
          <form
            v-if="loginType === 3"
            class="account-form"
            @submit.prevent="phoneCodeSubmit"
          >
            <div class="form-item">
              <i-input
                v-model="cellphone"
                type="text"
                placeholder="请输入手机号"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-phone" slot="prefix" />
              </i-input>
            </div>
            <div class="form-item">
              <i-input
                v-model="imageCode"
                maxlength="4"
                placeholder="请输入验证码"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-diamond" slot="prefix" />
                <span class="verify-code" @click="getCodeUrl()" slot="suffix">
                  <img
                    id="verifyCode"
                    title="点击刷新"
                    alt="验证码"
                    :src="verifyCodeUrl"
                    style="cursor: pointer"
                  />
                </span>
              </i-input>
            </div>
            <div class="form-item">
              <i-input
                v-model="phoneCode"
                maxlength="6"
                placeholder="请输入验证码"
                size="large"
              >
                <Icon custom="ich-icon ich-icon-diamond" slot="prefix" />
                <a class="phone-code" @click="getPhoneCode()" slot="suffix">
                  {{ phoneCodeText }}
                </a>
              </i-input>
            </div>
            <div class="form-item clearfix">
              <label class="fl">
                <Checkbox v-model="autoLogin">下次自动登录</Checkbox>
              </label>
            </div>
            <div class="form-item">
              <button type="submit" class="submit-btn">登 录</button>
            </div>
          </form>

          <router-link
            :to="{ name: 'Register' }"
            v-if="siteConfig.isAllowRegister"
            class="form-reg color3"
          >
            <template v-if="siteConfig.agencyId === 3963">
              没有账号？立即试看
            </template>
            <template v-else>没有账号？立即注册</template>
          </router-link>
        </div>
      </div>
      <div class="account-tips">
        <Icon custom="ich-icon ich-icon-warning" size="18"></Icon>
        <span
          >友情提示：推荐使用360（极速模式）、搜狗（高速模式）、谷歌浏览器</span
        >
      </div>
    </div>
    <div class="account-footer">
      <div class="footer-box">
        <div class="footer-info">
          <div class="info-content">
            <template v-if="siteConfig.footerTel && isContact"
              >咨询热线：{{ siteConfig.footerTel }}</template
            >
            <br />工业和信息化部备案号：
            <a href="https://beian.miit.gov.cn" target="_blank">{{
              siteConfig.icpNumber
            }}</a>
          </div>
          <div class="info-content">
            <template v-if="siteConfig.footerQQ && isContact">
              QQ：{{ siteConfig.footerQQ }}</template
            >
            <br />
            <template v-if="siteConfig.title"> {{ siteConfig.title }}</template>
          </div>
        </div>
        <div class="footer-qrcode" v-show="siteConfig.isShowAppQrcode">
          <div class="qrcode-title">APP客户端</div>
          <div class="qrcode-img">
            <!-- <template v-if="!isCustomApp">
              <img src="../../assets/images/app-qrcode.png" alt="qrcode" />
            </template> -->
            <template>
              <vue-qr
                :margin="5"
                :size="90"
                :correctLevel="3"
                :text="appQrcodeData.url"
                :logoSrc="appQrcodeData.icon"
                :logoMargin="5"
                style="display: block"
              ></vue-qr>
            </template>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="userListModalVisible"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
      width="360"
      class-name="vertical-center-modal"
    >
      <div class="modal-title">
        系统检测到该手机号有多个用户<br />请选择一个
      </div>
      <ul class="modal-list">
        <li
          v-for="(item, index) in userList"
          :key="index"
          @click="selectUser(item)"
        >
          {{ item.userName }}
        </li>
      </ul>
    </Modal>
    <Modal
      v-model="weekSetMobile"
      :closable="true"
      :mask-closable="false"
      :footer-hide="true"
      width="500"
      class-name="vertical-center-modal"
    >
      <AccountBindPhone />
    </Modal>
    <!--修改用户名 -->
    <Modal
      v-model="userVisible"
      title="修改用户名"
      ok-text="立即前往"
      cancel-text="回到首页"
      @on-ok="handleOk"
      @on-cancel="cancel"
      class-name="vertical-center-modal"
    >
      <h3 style="height: 100px; line-height: 100px">
        {{ tipText }}
      </h3>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { randomNum, checkWeakPassword } from "../../utils/utils";
import { account } from "../../request";
import VueQr from "vue-qr";
import AccountBindPhone from "../member/AccountBindPhone.vue";

export default {
  mixins: [siteMixin],
  data() {
    return {
      verifyCodeUrl: "",
      verifyCode: 0,
      errorTip: "",
      autoLogin: false,
      loginType: 1,
      customLoginId: 3328, //用于定制短信验证码登录的机构Id
      userPlaceholder: "请输入账号",
      username: "",
      password: "",
      userList: [],
      userInfo: {
        agencyId: null,
        userName: "",
      },
      userListModalVisible: false,
      appQrcodeData: {
        url: "",
        icon: "",
      },
      isCustomApp: false,
      cellphone: "",
      imageCode: "",
      phoneCode: "",
      phoneCodeText: "获取验证码",
      weekSetMobile: false,
      isContact: true,
      userVisible: false,
      tipText: "检测到您的用户名疑似包含手机号，建议前往用户中心修改用户名",
    };
  },
  mounted() {
    // 当前agencyId为0  并且域名不是本公司其下域名，则隐藏
    const hostname = window.location.hostname;
    if (
      this.siteConfig.agencyId === 0 &&
      hostname !== process.env.VUE_APP_WEB_DOMAIN
    ) {
      this.isContact = false;
    }
    this.setMetaData("用户登录");
    this.getCodeUrl();
    this.setQrCode();

    //定制登录
    if (this.siteConfig.agencyId == this.customLoginId) {
      this.changeLoginType(3);
    }
  },
  methods: {
    changeLoginType(type) {
      this.loginType = type;
      if (type === 1) {
        this.userPlaceholder = "请输入账号";
      } else {
        this.userPlaceholder = "请输入手机号";
      }
      if (type === 2) {
        this.checkUserName();
      }
    },
    getCodeUrl() {
      var baseUrl = process.env.VUE_APP_VERIFY_CODE_URL;
      this.verifyCode = randomNum(100000, 999999);
      this.verifyCodeUrl = baseUrl + this.verifyCode;
    },
    checkUserName(e) {
      const userName = this.username;
      if (!/^[1][3456789]\d{9}$/.test(userName) || this.loginType === 1) return;
      account
        .checkUsernameWithCellphone(this.siteConfig.agencyId, userName)
        .then((res) => {
          console.log(res);
          if (res.status === 1) {
            if (res.data.length > 0) {
              this.userInfo = res.data[0];
            }
            if (res.data.length > 1) {
              this.userList = res.data;
              this.userListModalVisible = true;
            }
          } else {
            console.log(res.message);
          }
        });
    },
    selectUser(item) {
      this.loginType = 1;
      this.username = item.userName;
      this.userListModalVisible = false;
    },

    submit(e) {
      const { verifycode } = e.target;
      if (!this.username) {
        if (this.loginType == 1) {
          this.errorTip = "请输入账号";
        } else {
          this.errorTip = "请输入手机号";
        }
        return;
      }
      if (this.password.value) {
        this.errorTip = "请输入密码";
        return;
      }
      if (this.password) {
        const passwordRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/;
        if (!passwordRegex.test(this.password)) {
          this.errorTip = " 密码不能包含：空格、中文、换行符及其他特殊符号!";
          return;
        }
      }
      if (!verifycode.value) {
        this.errorTip = "请输入验证码";
        return;
      }
      let data = {
        type: this.loginType,
        username: this.username,
        password: this.$md5(this.password),
        verify: verifycode.value,
        machine: this.$base64.encode(randomNum(1000, 9999)),
        randomNum: this.verifyCode,
        agencyid: this.siteConfig.agencyId,
        mobileagencyid: this.userInfo.AgencyId,
        mobileusername: this.userInfo.userName,
      };
      account.userLogin(data).then(async (result) => {
        //console.log(result);
        if (result.status === 1) {
          localStorage.removeItem("weekPassChange");
          this.login(result.data);
          if (result.data.suspectedPhone) {
            this.userVisible = true;
            return;
          }
          //const flag = await checkWeakPassword(this.password)
          // 2024/10/16 去掉登录弱密码校验
          const flag = true;
          if (!flag) {
            localStorage.setItem("weekPassChange", "none");
            this.$Modal.warning({
              title: "提示",
              content: "该密码过于简单，请重新设置。",
              onOk: () => {
                if (result.data.mobile) {
                  this.$router.push({
                    path: "/forget",
                    query: { weekPass: true },
                  });
                } else {
                  this.weekSetMobile = true;
                }
              },
            });
            return;
          }
          this.$router.replace({
            path: this.$route.query.redirect || "/member",
          });
        } else {
          this.errorTip = result.message;
        }
      });
    },
    //获取手机验证码
    getPhoneCode() {
      if (!this.isRequest) {
        if (!this.cellphone) {
          this.errorTip = "请输入您的手机号";
          return;
        }
        this.isRequest = true;
        let data = {
          mobile: this.cellphone,
          imgCode: this.imageCode,
          randomNum: this.verifyCode,
        };
        account
          .getPhoneCodeWithImageCode(data)
          .then((result) => {
            if (result.status == 1) {
              let second = 60;
              let timer = setInterval(() => {
                second--;
                this.phoneCodeText = `还剩 ${second} 秒`;
                //console.log(second);
                if (second === 0) {
                  this.isRequest = false;
                  this.phoneCodeText = "重新获取";
                  clearInterval(timer);
                }
              }, 1000);
              this.errorTip = "";
            } else {
              this.isRequest = false;
              this.errorTip = result.message;
            }
          })
          .catch(() => {
            this.isRequest = false;
            this.$Message.error("请求异常");
          });
      }
    },
    phoneCodeSubmit() {
      if (this.loginType !== 3) return;
      if (!this.cellphone) {
        this.errorTip = "请输入手机号";
        return;
      }
      if (!this.phoneCode) {
        this.errorTip = "请输入验证码";
        return;
      }
      let data = {
        mobile: this.cellphone,
        verifyCode: this.phoneCode,
      };
      account.phoneCodeLogin(data).then((result) => {
        if (result.status === 1) {
          this.login(result.data);
          this.$router.push({ name: "MemberCenter" });
        } else {
          this.errorTip = result.message;
        }
      });
    },
    setQrCode() {
      this.appQrcodeData = {
        url: window.location.protocol + "//" + document.domain + "/app",
        icon: this.concatImageUrl(this.siteConfig.qrCodeLogo),
      };
    },
    handleOk() {
      this.userVisible = false;
      this.$router.replace({
        path: "/member/account",
      });
    },
    cancel() {
      this.userVisible = false;
      this.$router.replace({
        path: "/member",
      });
    },
  },
  components: {
    VueQr,
    AccountBindPhone,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";

.account-header {
  // position: absolute;
  // left: 0;
  // top: 0;
  width: 100%;
  // height: 100px;
  background: #fff;
  z-index: 200;
  .header-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .header-logo {
      width: 250px;
      height: 50px;
      margin: 15px 0;
      overflow: hidden;
      img {
        max-height: 50px;
        max-width: 250px;
      }
    }
  }
}
.account-body {
  // position: absolute;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  width: 100%;
  height: 720px;
  background: url(../../assets/images/v3/account-bg.png) #001351 center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .account-box {
    width: 1060px;
    height: 450px;
    display: flex;
    border-radius: 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
    overflow: hidden;
    .account-img {
      width: 670px;
      height: 100%;
      background: rgba(255, 255, 255, 0.1);
      .img {
        width: 100%;
        height: 100%;
        background-size: 100% !important;
      }
    }
    .account-wrapper {
      width: 390px;
      height: 450px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px 30px;
      .account-tab {
        width: 100%;
        height: 30px;
        &.col3 {
          span {
            width: 100%;
            //width: 33.3%;
          }
        }
        span {
          .inline-block();
          width: 50%;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #86888b;
          cursor: pointer;
          &.selected {
            color: #2596fd;
          }
          & + span {
            border-left: 1px solid #ccc;
          }
        }
      }
      .account-error {
        display: flex;
        width: 100%;
        padding-bottom: 8px;
        line-height: 1.2;
        color: #ff4500;
        span {
          margin-left: 4px;
        }
      }
      .account-form {
        width: 100%;
        .form-item {
          & + .form-item {
            padding-top: 24px;
          }
          i {
            color: #d1d2d4;
            line-height: 38px;
          }
          .ivu-input-suffix {
            .ivu-icon {
              font-size: 24px;
              line-height: 40px;
            }
          }
          .ivu-input {
            border-radius: 8px;
          }
          .verify-code {
            width: 100px;
            height: 100%;
            float: right;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .phone-code {
            width: 100px;
            height: 38px;
            line-height: 38px;
            float: right;
            margin: 1px 1px 0 0;
            background: #f7f7f7;
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
            color: #999;
          }
          .submit-btn {
            width: 100%;
            height: 40px;
            border: none;
            .background-primary();
            text-align: center;
            border-radius: 8px;
            outline: none;
            cursor: pointer;
          }
        }
      }
      .form-reg {
        width: 100%;
        display: inline-block;
        text-align: center;
        margin-top: 20px;
      }
    }
  }
  .account-tips {
    width: 1060px;
    padding: 20px 0;
    i {
      color: #eabe14;
    }
    span {
      .inline-block();
      color: #fff;
      margin-left: 10px;
    }
  }
}
.account-footer {
  // position: absolute;
  // left: 0;
  // bottom: 0;
  width: 100%;
  padding: 20px 0;
  background: #fff;
  z-index: 200;
  .footer-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    // justify-content: center;
    .footer-info {
      display: flex;
      height: 120px;
      padding: 10px;
      .info-content {
        line-height: 50px;
        margin-right: 60px;
      }
    }
    .footer-qrcode {
      margin-left: 60px;
      width: 100px;
      .qrcode-title {
        text-align: center;
        // font-weight: bold;
        font-size: 16px;
        color: #666;
        height: 30px;
        line-height: 30px;
      }
      .qrcode-img {
        width: 90px;
        margin: 0 auto;
        img {
          width: 90px;
          height: 90px;
        }
      }
    }
  }
}

.modal-title {
  font-size: 1.6rem;
  padding: 25px 10px 25px 10px;
  text-align: center;
}
.modal-list {
  width: 220px;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 20px;
  li {
    .inline-block();
    margin: 0 10px;
    padding: 5px 16px;
    background: #eee;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
      background-color: #0e90d2;
      color: #fff;
    }
  }
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}
</style>
